import Navbar from "../../component/Navbar";
import DropdownMenu from "../../component/DropdownMenu";
import LogoContent from "../../component/LogoContent";
import Footer from "../../component/Footer";
import { useState } from "react";
import PageTransition from "../../component/PageTransition";

export default function Page() {
  const [showContent, setShowContent] = useState(false);

  return (
    <>
      <PageTransition showContent={showContent} setShowContent={setShowContent}>
        ประวัติความเป็นมาศูนย์การเรียนรู้และส่งเสริมสุขภาพทางสัตวแพทย์ภาคเหนือ
      </PageTransition>
      {showContent && (
        <div className="relative">
          <Navbar />
          <div className="flex flex-col gap-y-5">
            <DropdownMenu />

            <div className="flex flex-col container mx-auto max-w-5xl lg:px-0 gap-y-5 px-5">
              <div className="relative lg:py-0 pt-10 ">
                <img
                  src="/images/banner/IMG_7055_Cover.JPG"
                  className="object-cover rounded-md"
                  alt=""
                ></img>
                <div className="md:block hidden absolute top-1/4  left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                  <LogoContent />
                </div>
                <div className="lg:absolute lg:bottom-0 lg:bg-gray-500/55 w-full lg:p-5 py-4 rounded-b-md">
                  <div className="lg:text-gray-200 text-gray-500">
                    <span className="lg:text-md text-sm">
                      ศูนย์สุขภาพสัตว์ดอยคำก่อสร้างในบริเวณ
                      ตั้งอยู่ในพื้นที่ศูนย์วิจัย
                      สาธิตและฝึกอบรมการเกษตรแม่เหียะ ต.แม่เหียะ อ.เมือง
                      จ.เชียงใหม่ ซึ่งเป็นบริเวณที่ตั้งของคณะสัตวแพทยศาสตร์
                      มหาวิทยาลัยเชียงใหม่ ณ ปัจจุบัน โดยจะเป็นอาคารสูง 4 ชั้น
                      มีพื้นที่ใช้สอยประมาณ 17,968 ตารางเมตร
                      และโครงการได้รับอนุมัติงบประมาณเพื่อก่อสร้างศูนย์สุขภาพสัตว์ดอยคำ
                      วงเงินงบประมาณ 270,000,000 บาท ตั้งแต่ปีงบประมาณ 2562 –
                      2565 ปัจจุบันอาคารดังกล่าวแล้วเสร็จเรียบร้อยแล้ว
                      และอยู่ในระหว่างดำเนินการตกแต่งภายในอาคาร
                      ให้มีความพร้อมเปิดให้บริการในปี 2568 โดยเปิดให้การรักษาโรค
                      เฉพาะทางอย่างครบวงจร ทั้งคลินิกเฉพาะทาง 14 คลินิก
                      และแผนกต่าง ๆ เช่น แผนกศัลยกรรม แผนกสัตว์ป่วยฉุกเฉิน
                      แผนกสัตว์ป่วยภาวะวิกฤต ฯลฯ พร้อมด้วยศูนย์กายภาพบำบัด
                      และสระว่ายน้ำธาราบำบัดในร่ม หออภิบาลสุนัขป่วย
                      หออภิบาลแมวป่วย หออภิบาลสัตว์ป่วยพิเศษ ไว้รองรับสัตว์ป่วย
                      ทั้งหมดนี้เพื่อให้ศูนย์สุขภาพสัตว์ดอยคำเป็นแหล่งความรู้คู่ความรัก(ษ์)
                      ที่สามารถใช้ องค์ความรู้ที่มีอยู่
                      ในการบำบัดรักษาสุขภาพสัตว์ทั้งหลายอย่างยั่งยืน
                      และเพื่อให้วิชาชีพสัตวแพทย์สามารถเป็นที่พึ่งให้แก่สังคมได้อย่างแท้จริง
                      และ ได้รับพระราชทานชื่ออาคาร สัตวเวชบำรุง หมายถึง
                      อาคารที่เป็นแหล่งบำรุงรักษาทางการแพทย์ให้แก่สัตว์
                      และพระราชทานพระราชนุญาตให้เชิญอักษรพระนามภิไธย{" "}
                      <b>"ส.ธ."</b>
                      ประดับที่ป้ายชื่อพระราชทาน
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      )}
    </>
  );
}
